<template>
    <CCol v-if="show">
        <CCard>
            <CCardBody>
                <CRow class="mb-1 align-items-center">
                    <CCol
                        cols="12"
                        md="12"
                        class="h5"> Экспорт заказов «{{ title }}» </CCol>
                    <CCol cols="12" md="2"> Дата начала: </CCol>
                    <CCol cols="12" md="3">
                        <DatePicker
                            v-model="datepicker.dateFrom"
                            :language="datepicker.lang"
                            :format="datepicker.format"
                            input-class="custom-datepicker"
                            placeholder="Выберите дату..."
                        />
                    </CCol>
                    <CCol cols="12" md="2"> Дата окончания: </CCol>
                    <CCol cols="12" md="3">
                        <DatePicker
                            v-model="datepicker.dateTo"
                            :language="datepicker.lang"
                            :format="datepicker.format"
                            input-class="custom-datepicker"
                            placeholder="Выберите дату..."
                        />
                    </CCol>
                    <CCol cols="12" md="2">
                        <CButton color="primary" @click="doExport">Экспорт</CButton>
                    </CCol>
                </CRow>
            </CCardBody>
        </CCard>
    </CCol>
</template>

<script>
    import Vue from 'vue';
    import DatePicker from 'vuejs-datepicker';
    import { ru } from 'vuejs-datepicker/dist/locale';
    import moment from 'moment';

    export default {
        name: 'PartnerReports',

        components: {
            DatePicker,
        },

        props: {
            partner: {
                type: Object,
                default: () => ({}),
            }
        },

        data() {
            return {
                isAuthorized: false,
                datepicker: {
                    lang: ru,
                    format: 'dd.MM.yyyy',
                    dateFrom: null,
                    dateTo: null,
                },
                isAv: false,
                show: false,
                isRest: false,
                isEntity: false,
                title: '',
            };
        },

        watch: {
            partner: 'checkGrocer',
        },

        methods: {
            async checkGrocer() {
                if (this?.partner?.id && this?.partner?.grocers.length !== 0) {
                    const [ AV ] = await Promise.all(this.partner.grocers.map(async id => {
                        const grocer = (await Vue.axios.get(`/grocers/${id}/`)).data;
                        if (grocer.alias === 'av') {
                            return grocer;
                        }
                        return {}
                    }));
    
                    this.isAv = !!AV.id;
                    this.show = this.isAv;
                    this.title = this.isAv ? 'Азбуки Вкуса' : '';
                } else if (this?.partner?.id && this?.partner?.restaurants.length !== 0){
                    const [ REST ] = await Promise.all(this.partner.restaurants.map(async id => {
                        const restaurant = (await Vue.axios.get(`/restaurants/${id}/`)).data;
                        return restaurant;
                    }));
    
                    this.isRest = !!REST.id;
                    this.show = this.isRest;
                    this.title = REST.title;
                }
                console.log(this.partner, 'partner');
                if (this?.partner?.id && this?.partner?.entities.length !== 0) {
                    const [ ENTITIES ] = await Promise.all(this.partner.entities.map(async id => {
                        const entity = (await Vue.axios.get(`/entities/get/${id}`)).data;
                        return entity;
                    }))

                    this.isEntity = !!ENTITIES.id;
                    this.show = this.isEntity;
                    this.title = ENTITIES.title;
                }
            },

            doExport() {
                if (!this.datepicker.dateFrom || !this.datepicker.dateTo) {
                    this.$root.$emit('showError', 'Укажите даты начала и окончания для экспорта');
                    return;
                }
                const dateFrom = moment(Date.parse(this.datepicker.dateFrom)).format('YYYY-MM-DD');
                const dateTo = moment(Date.parse(this.datepicker.dateTo)).format('YYYY-MM-DD');
                if (this.isAv) {
                    Vue.axios
                    .get(
                        `/export/av?dateFrom=${dateFrom}&dateTo=${dateTo}&avId=${this?.partner?.id}`,
                        { responseType: 'blob' }
                    )
                    .then(response => {
                        const bom = decodeURIComponent('%ef%bb%bf')
                        const fileURL = window.URL.createObjectURL(new Blob([bom, response.data], { type: 'text/csv;charset=utf-8' }));
                        const fileLink = document.createElement('a');
                        fileLink.href = fileURL;
                        fileLink.setAttribute(
                            'download',
                            'Export-' + dateFrom + '-' + dateTo + '.csv'
                        );
                        document.body.appendChild(fileLink);

                        fileLink.click();
                    });
                } else if (this.isRest){
                    Vue.axios
                    .get(
                        `/export/restaurant?dateFrom=${dateFrom}&dateTo=${dateTo}&partnerId=${this?.partner?.id}`,
                        { responseType: 'blob' }
                    )
                    .then(response => {
                        const bom = decodeURIComponent('%ef%bb%bf')
                        const fileURL = window.URL.createObjectURL(new Blob([bom, response.data], { type: 'text/csv;charset=utf-8' }));
                        const fileLink = document.createElement('a');
                        fileLink.href = fileURL;
                        fileLink.setAttribute(
                            'download',
                            'Export-' + dateFrom + '-' + dateTo + '.csv'
                        );
                        document.body.appendChild(fileLink);

                        fileLink.click();
                    });
                } else if (this.isEntity) {
                    Vue.axios
                        .get(
                            `/export/entity?dateFrom=${dateFrom}&dateTo=${dateTo}&partnerId=${this?.partner?.id}`,
                            { responseType: 'blob' }
                        )
                        .then(response => {
                            const bom = decodeURIComponent('%ef%bb%bf')
                            const fileURL = window.URL.createObjectURL(new Blob([bom, response.data], { type: 'text/csv;charset=utf-8' }));
                            const fileLink = document.createElement('a');
                            fileLink.href = fileURL;
                            fileLink.setAttribute(
                                'download',
                                'Export-' + dateFrom + '-' + dateTo + '.csv'
                            );
                            document.body.appendChild(fileLink);

                            fileLink.click();
                        });
                }
            },
        },
    };
</script>

<style>
input.custom-datepicker {
  border: 1px solid;
  border-color: #d8dbe0;
  width: 100%;
}
.header-with-nav ul.nav.nav-tabs {
    border-bottom: 0;
}
</style>